package team.platforma.multiplatform_material_extension.ui.core.global_style

import androidx.compose.material3.OutlinedTextFieldDefaults
import androidx.compose.material3.TextFieldColors
import androidx.compose.material3.TextFieldDefaults
import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.Color

/**
 * [TextFieldColorScheme].apply {
 *
 * //Text
 *
 * &nbsp;&nbsp;&nbsp;&nbsp;[focusedTextColor] =
 *
 * &nbsp;&nbsp;&nbsp;&nbsp;[unfocusedTextColor] =
 *
 * &nbsp;&nbsp;&nbsp;&nbsp;[disabledTextColor] =
 *
 * &nbsp;&nbsp;&nbsp;&nbsp;[errorTextColor] =
 *
 * //Container
 *
 * &nbsp;&nbsp;&nbsp;&nbsp;[focusedContainerColor] =
 *
 * &nbsp;&nbsp;&nbsp;&nbsp;[unfocusedContainerColor] =
 *
 * &nbsp;&nbsp;&nbsp;&nbsp;[disabledContainerColor] =
 *
 * &nbsp;&nbsp;&nbsp;&nbsp;[errorContainerColor] =
 *
 * //Cursor
 *
 * &nbsp;&nbsp;&nbsp;&nbsp;[cursorColor] =
 *
 * &nbsp;&nbsp;&nbsp;&nbsp;[errorCursorColor] =
 *
 * //Indicator
 *
 * &nbsp;&nbsp;&nbsp;&nbsp;[focusedIndicatorColor] =
 *
 * &nbsp;&nbsp;&nbsp;&nbsp;[unfocusedIndicatorColor] =
 *
 * &nbsp;&nbsp;&nbsp;&nbsp;[disabledIndicatorColor] =
 *
 * &nbsp;&nbsp;&nbsp;&nbsp;[errorIndicatorColor] =
 *
 * //LeadingIcon
 *
 * &nbsp;&nbsp;&nbsp;&nbsp;[focusedLeadingIconColor] =
 *
 * &nbsp;&nbsp;&nbsp;&nbsp;[unfocusedLeadingIconColor] =
 *
 * &nbsp;&nbsp;&nbsp;&nbsp;[disabledLeadingIconColor] =
 *
 * &nbsp;&nbsp;&nbsp;&nbsp;[errorLeadingIconColor] =
 *
 * //TrailingIcon
 *
 * &nbsp;&nbsp;&nbsp;&nbsp;[focusedTrailingIconColor] =
 *
 * &nbsp;&nbsp;&nbsp;&nbsp;[unfocusedTrailingIconColor] =
 *
 * &nbsp;&nbsp;&nbsp;&nbsp;[disabledTrailingIconColor] =
 *
 * &nbsp;&nbsp;&nbsp;&nbsp;[errorTrailingIconColor] =
 *
 * //Label
 *
 * &nbsp;&nbsp;&nbsp;&nbsp;[focusedLabelColor] =
 *
 * &nbsp;&nbsp;&nbsp;&nbsp;[unfocusedLabelColor] =
 *
 * &nbsp;&nbsp;&nbsp;&nbsp;[disabledLabelColor] =
 *
 * &nbsp;&nbsp;&nbsp;&nbsp;[errorLabelColor] =
 *
 * //Placeholder
 *
 * &nbsp;&nbsp;&nbsp;&nbsp;[focusedPlaceholderColor] =
 *
 * &nbsp;&nbsp;&nbsp;&nbsp;[unfocusedPlaceholderColor] =
 *
 * &nbsp;&nbsp;&nbsp;&nbsp;[disabledPlaceholderColor] =
 *
 * &nbsp;&nbsp;&nbsp;&nbsp;[errorPlaceholderColor] =
 *
 * //SupportingText
 *
 * &nbsp;&nbsp;&nbsp;&nbsp;[focusedSupportingTextColor] =
 *
 * &nbsp;&nbsp;&nbsp;&nbsp;[unfocusedSupportingTextColor] =
 *
 * &nbsp;&nbsp;&nbsp;&nbsp;[disabledSupportingTextColor] =
 *
 * &nbsp;&nbsp;&nbsp;&nbsp;[errorSupportingTextColor] =
 *
 * //Prefix
 *
 * &nbsp;&nbsp;&nbsp;&nbsp;[focusedPrefixColor] =
 *
 * &nbsp;&nbsp;&nbsp;&nbsp;[unfocusedPrefixColor] =
 *
 * &nbsp;&nbsp;&nbsp;&nbsp;[disabledPrefixColor] =
 *
 * &nbsp;&nbsp;&nbsp;&nbsp;[errorPrefixColor] =
 *
 * //Suffix
 *
 * &nbsp;&nbsp;&nbsp;&nbsp;[focusedSuffixColor] =
 *
 * &nbsp;&nbsp;&nbsp;&nbsp;[unfocusedSuffixColor] =
 *
 * &nbsp;&nbsp;&nbsp;&nbsp;[disabledSuffixColor] =
 *
 * &nbsp;&nbsp;&nbsp;&nbsp;[errorSuffixColor] =
 *
 * }
 */
object TextFieldColorScheme {

    var focusedTextColor: Color? = null
    var unfocusedTextColor: Color? = null
    var disabledTextColor: Color? = null
    var errorTextColor: Color? = null

    var focusedContainerColor: Color? = null
    var unfocusedContainerColor: Color? = null
    var disabledContainerColor: Color? = null
    var errorContainerColor: Color? = null

    var cursorColor: Color? = null
    var errorCursorColor: Color? = null

    var focusedIndicatorColor: Color? = null
    var unfocusedIndicatorColor: Color? = null
    var disabledIndicatorColor: Color? = null
    var errorIndicatorColor: Color? = null

    var focusedLeadingIconColor: Color? = null
    var unfocusedLeadingIconColor: Color? = null
    var disabledLeadingIconColor: Color? = null
    var errorLeadingIconColor: Color? = null

    var focusedTrailingIconColor: Color? = null
    var unfocusedTrailingIconColor: Color? = null
    var disabledTrailingIconColor: Color? = null
    var errorTrailingIconColor: Color? = null

    var focusedLabelColor: Color? = null
    var unfocusedLabelColor: Color? = null
    var disabledLabelColor: Color? = null
    var errorLabelColor: Color? = null

    var focusedPlaceholderColor: Color? = null
    var unfocusedPlaceholderColor: Color? = null
    var disabledPlaceholderColor: Color? = null
    var errorPlaceholderColor: Color? = null

    var focusedSupportingTextColor: Color? = null
    var unfocusedSupportingTextColor: Color? = null
    var disabledSupportingTextColor: Color? = null
    var errorSupportingTextColor: Color? = null

    var focusedPrefixColor: Color? = null
    var unfocusedPrefixColor: Color? = null
    var disabledPrefixColor: Color? = null
    var errorPrefixColor: Color? = null

    var focusedSuffixColor: Color? = null
    var unfocusedSuffixColor: Color? = null
    var disabledSuffixColor: Color? = null
    var errorSuffixColor: Color? = null
}

@Composable
internal fun setOutlinedTextFieldDefaults(): TextFieldColors {
    val global = TextFieldColorScheme
    val default = OutlinedTextFieldDefaults.colors()

    return OutlinedTextFieldDefaults.colors().define(global, default)
}

@Composable
internal fun setFiledTextFieldDefaults(): TextFieldColors {
    val global = TextFieldColorScheme
    val default = TextFieldDefaults.colors()

    return TextFieldDefaults.colors().define(global, default)
}

@Composable
private fun TextFieldColors.define(
    global: TextFieldColorScheme,
    default: TextFieldColors
): TextFieldColors {
    return this.copy(
        focusedTextColor = global.focusedTextColor ?: default.focusedTextColor,
        unfocusedTextColor = global.unfocusedTextColor ?: default.unfocusedTextColor,
        disabledTextColor = global.disabledTextColor ?: default.disabledTextColor,
        errorTextColor = global.errorTextColor ?: default.errorTextColor,

        focusedContainerColor = global.focusedContainerColor ?: default.focusedContainerColor,
        unfocusedContainerColor = global.unfocusedContainerColor ?: default.unfocusedContainerColor,
        disabledContainerColor = global.disabledContainerColor ?: default.disabledContainerColor,
        errorContainerColor = global.errorContainerColor ?: default.errorContainerColor,

        cursorColor = global.cursorColor ?: default.cursorColor,
        errorCursorColor = global.errorCursorColor ?: default.errorCursorColor,

        focusedIndicatorColor = global.focusedIndicatorColor ?: default.focusedIndicatorColor,
        unfocusedIndicatorColor = global.unfocusedIndicatorColor ?: default.unfocusedIndicatorColor,
        disabledIndicatorColor = global.disabledIndicatorColor ?: default.disabledIndicatorColor,
        errorIndicatorColor = global.errorIndicatorColor ?: default.errorIndicatorColor,

        focusedLeadingIconColor = global.focusedLeadingIconColor ?: default.focusedLeadingIconColor,
        unfocusedLeadingIconColor = global.unfocusedLeadingIconColor
            ?: default.unfocusedLeadingIconColor,
        disabledLeadingIconColor = global.disabledLeadingIconColor
            ?: default.disabledLeadingIconColor,
        errorLeadingIconColor = global.errorLeadingIconColor ?: default.errorLeadingIconColor,

        focusedTrailingIconColor = global.focusedTrailingIconColor
            ?: default.focusedTrailingIconColor,
        unfocusedTrailingIconColor = global.unfocusedTrailingIconColor
            ?: default.unfocusedTrailingIconColor,
        disabledTrailingIconColor = global.disabledTrailingIconColor
            ?: default.disabledTrailingIconColor,
        errorTrailingIconColor = global.errorTrailingIconColor ?: default.errorTrailingIconColor,

        focusedLabelColor = global.focusedLabelColor ?: default.focusedLabelColor,
        unfocusedLabelColor = global.unfocusedLabelColor ?: default.unfocusedLabelColor,
        disabledLabelColor = global.disabledLabelColor ?: default.disabledLabelColor,
        errorLabelColor = global.errorLabelColor ?: default.errorLabelColor,

        focusedPlaceholderColor = global.focusedPlaceholderColor ?: default.focusedPlaceholderColor,
        unfocusedPlaceholderColor = global.unfocusedPlaceholderColor
            ?: default.unfocusedPlaceholderColor,
        disabledPlaceholderColor = global.disabledPlaceholderColor
            ?: default.disabledPlaceholderColor,
        errorPlaceholderColor = global.errorPlaceholderColor ?: default.errorPlaceholderColor,

        focusedSupportingTextColor = global.focusedSupportingTextColor
            ?: default.unfocusedSupportingTextColor,
        unfocusedSupportingTextColor = global.unfocusedSupportingTextColor
            ?: default.unfocusedSupportingTextColor,
        disabledSupportingTextColor = global.disabledSupportingTextColor
            ?: default.disabledSupportingTextColor,
        errorSupportingTextColor = global.errorSupportingTextColor
            ?: default.errorSupportingTextColor,

        focusedPrefixColor = global.focusedPrefixColor ?: default.focusedPrefixColor,
        unfocusedPrefixColor = global.unfocusedPrefixColor ?: default.unfocusedPrefixColor,
        disabledPrefixColor = global.disabledPrefixColor ?: default.disabledPrefixColor,
        errorPrefixColor = global.errorPrefixColor ?: default.errorPrefixColor,

        focusedSuffixColor = global.focusedSuffixColor ?: default.focusedSuffixColor,
        unfocusedSuffixColor = global.unfocusedSuffixColor ?: default.unfocusedSuffixColor,
        disabledSuffixColor = global.disabledSuffixColor ?: default.disabledSuffixColor,
        errorSuffixColor = global.errorSuffixColor ?: default.errorSuffixColor,
        )
}




